// src/registerServiceWorker.js
import { register } from 'register-service-worker'
import packageJson from '../package.json'

const currentVersion = packageJson.version;

register(`${process.env.BASE_URL}service-worker.js`, {
    updated(registration) {

        // Force cache clear and reload
        if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });

            caches.keys().then(keys => {
                return Promise.all(keys.map(key => caches.delete(key)));
            }).finally(() => {
                localStorage.setItem('version', currentVersion);
                window.location.reload();
            });
        }
    },
    error(error) {
        console.error('Error during service worker registration:', error)
    },
})

